import { api } from './client';
import type { Task, TaskCounts, CalendarEvent, Paginated } from '@/types';

export const tasksApi = {
  async list(filters: { status?: string; priority?: string; assignee?: number; mine?: boolean } = {}): Promise<Task[]> {
    const params: Record<string, string | number> = {};
    if (filters.status) params.status = filters.status;
    if (filters.priority) params.priority = filters.priority;
    if (filters.assignee) params.assignee = filters.assignee;
    if (filters.mine) params.mine = '1';
    const { data } = await api.get<Paginated<Task>>('/tasks/', { params });
    return data.results ?? (data as unknown as Task[]);
  },
  async create(payload: Partial<Task>): Promise<Task> {
    const { data } = await api.post<Task>('/tasks/', payload);
    return data;
  },
  async update(id: number, payload: Partial<Task>): Promise<Task> {
    const { data } = await api.patch<Task>(`/tasks/${id}/`, payload);
    return data;
  },
  async complete(id: number): Promise<Task> { return (await api.post(`/tasks/${id}/complete/`)).data; },
  async reopen(id: number): Promise<Task> { return (await api.post(`/tasks/${id}/reopen/`)).data; },
  async remove(id: number): Promise<void> { await api.delete(`/tasks/${id}/`); },
  async counts(): Promise<TaskCounts> { return (await api.get('/tasks/counts/')).data; },
  async calendar(start: string, end: string): Promise<CalendarEvent[]> {
    const { data } = await api.get<CalendarEvent[]>('/calendar-events/', { params: { start, end } });
    return data;
  },
};
